export const productConstants = {
    CREATE_PRODUCT_REQUEST: 'CREATE_PRODUCT_REQUEST',
    CREATE_PRODUCT_SUCCESS: 'CREATE_PRODUCT_SUCCESS',
    CREATE_PRODUCT_FAILURE: 'CREATE_PRODUCT_FAILURE'

};
